import {useDispatch} from "react-redux";
import {logOut} from "../../../redux/slice/authSlice";
import useCheckoutStore from "../../../newStructure/cart/store/checkoutStore";

const useLogOut = () => {

    const dispatch = useDispatch();
    const clearCart = useCheckoutStore(state => state.clearCart);

    return () => {
        dispatch(logOut());
        clearCart();
    };
}

export default useLogOut;